import { FirestoreDataConverter } from 'firebase/firestore';
import { Scavenger } from '../../Scavenger/types';
import { toImageFireStoreModel, toImageInternalModel } from './imageConverter';

const scavengerConverter: FirestoreDataConverter<Scavenger> = {
  toFirestore: (model: Scavenger) => {
    return {
      current_step: model.currentStep,
    };
  },
  fromFirestore: (snapshot) => {
    const data = snapshot.data();
    return {
      id: snapshot.id,
      currentStep: data.current_step,
    };
  },
};

export default scavengerConverter;
